/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilterCreator_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuMultiSelectSearch_viewer">;
    readonly " $refType": "SbSharedRefineMenuFilterCreator_viewer";
};
export type SbSharedRefineMenuFilterCreator_viewer$data = SbSharedRefineMenuFilterCreator_viewer;
export type SbSharedRefineMenuFilterCreator_viewer$key = {
    readonly " $data"?: SbSharedRefineMenuFilterCreator_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterCreator_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterCreator_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelectSearch_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '0e18e5187b12e17e380593bb93529af4';
export default node;
